import { putHtmlCodeToDom } from "@devowl-wp/headless-content-unblocker";
import { getServiceSelection } from "../decision/getServiceSelection.js";
import { OPT_IN_EVENT } from "../events/optIn.js";
/**
 * Opt-in to a set of services.
 */ async function applyOptIn(options) {
    const allOptInServices = [];
    const { isManagerActive, iterateServices } = getServiceSelection(options);
    const { skipOptIn } = options;
    // Handle managers like GTM and MTM
    let isManagerOptOut = false;
    let dataLayer = undefined;
    const waitPromises = [];
    // Handle opt-ins sequentially
    await iterateServices(async (group, service, isOptIn, param)=>{
        let { getDataLayer, serviceIsManager } = param;
        const { codeDynamics, codeOptIn, executeCodeOptInWhenNoTagManagerConsentIsGiven } = service;
        const isManager = isManagerActive && serviceIsManager;
        if (isOptIn) {
            // Check if the script should explicitly only be loaded if no consent is given to the manager
            const isOnlyWhenNoConsentToManager = isManagerActive && executeCodeOptInWhenNoTagManagerConsentIsGiven;
            const isSkipOptIn = typeof skipOptIn === "function" ? skipOptIn(service) : false;
            // If this is a manager, calculate consent data for the datalayer and push it
            /* Silence is golden... Until you have PRO Version! */ if (!isOnlyWhenNoConsentToManager && !isSkipOptIn && codeOptIn) {
                waitPromises.push(putHtmlCodeToDom(codeOptIn, codeDynamics));
            }
            const summary = {
                group,
                service
            };
            document.dispatchEvent(new CustomEvent(OPT_IN_EVENT, {
                detail: summary
            }));
            allOptInServices.push(summary);
        } else if (isManager) {
        /* Silence is golden... Until you have PRO Version! */ }
    });
    return {
        isManagerOptOut,
        dataLayer,
        services: allOptInServices,
        ready: Promise.all(waitPromises)
    };
}
export { applyOptIn };
